module.exports = __webpack_public_path__ + "img/update-package.8c8531ae.svg";